import { useSyncExternalStore } from "react";

export const CONQUESTS_DEV_SELF_PREVIEW_KEY =
  "conquests.dev_self_preview_enabled" as const;

let enabled = false;
const listeners = new Set<() => void>();

/** Project the dedicated deployment switch from the shared public envelope. */
export function parseDevSelfPreviewEnabled(
  flags: Record<string, boolean> | null | undefined,
): boolean {
  return flags?.[CONQUESTS_DEV_SELF_PREVIEW_KEY] === true;
}

export function setDevSelfPreviewEnabled(value: boolean): void {
  if (value === enabled) return;
  enabled = value;
  for (const listener of listeners) listener();
}

export function readDevSelfPreviewEnabled(): boolean {
  return enabled;
}

export function subscribeDevSelfPreview(listener: () => void): () => void {
  listeners.add(listener);
  return () => listeners.delete(listener);
}

export function useDevSelfPreviewEnabled(): boolean {
  return useSyncExternalStore(
    subscribeDevSelfPreview,
    readDevSelfPreviewEnabled,
    readDevSelfPreviewEnabled,
  );
}

export function resetDevSelfPreviewForTests(): void {
  enabled = false;
  listeners.clear();
}
